import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { reduxKey } from './constants';
import { setPushSubscriptionState } from './actions';
import { PushSubscriptionState } from './types';
import { handleActions } from 'redux-actions';
const defaultState = {
    pushSubscriptionState: PushSubscriptionState.LOADING
};
const actionHandlers = handleActions({
    [setPushSubscriptionState.toString()]: (state, { payload })=>_object_spread_props(_object_spread({}, state), {
            pushSubscriptionState: payload.newState
        })
}, defaultState);
const reducers = {
    [reduxKey]: actionHandlers
};
export default reducers;

//# sourceMappingURL=reducers.js.map